export function buildWave(index, tutorialLevel) {
    if (tutorialLevel != null)
        return buildTutorialWave(index);
    const baseCount = 8 + index * 2;
    const spawns = [
        { type: "grunt", count: baseCount, delayMs: 0, spacingMs: 600 },
    ];
    if (index >= 2) {
        spawns.push({ type: "runner", count: Math.min(15, 3 + index), delayMs: 4000, spacingMs: 350 });
    }
    if (index >= 4 && index % 2 === 0) {
        spawns.push({ type: "armored", count: 4 + Math.floor(index / 2), delayMs: 8000, spacingMs: 800 });
    }
    if (index >= 5) {
        spawns.push({ type: "flyer", count: 3 + Math.floor(index / 3), delayMs: 6000, spacingMs: 700 });
    }
    if (index >= 8 && index % 3 === 0) {
        spawns.push({ type: "swarm", count: 18, delayMs: 12000, spacingMs: 180 });
    }
    if (index > 0 && index % 5 === 0) {
        spawns.push({ type: "tank", count: 2 + Math.floor(index / 5), delayMs: 10000, spacingMs: 1500 });
    }
    if (index > 0 && index % 10 === 0) {
        spawns.push({ type: "boss", count: 1, delayMs: 18000, spacingMs: 0 });
    }
    return { index, spawns };
}
function buildTutorialWave(index) {
    const spawns = [
        { type: "grunt", count: 4 + index, delayMs: 0, spacingMs: 700 },
    ];
    if (index >= 3) {
        spawns.push({
            type: "runner",
            count: Math.max(1, Math.floor((3 + index) / 2)),
            delayMs: 4500,
            spacingMs: 450,
        });
    }
    if (index >= 5 && index % 2 === 0) {
        spawns.push({
            type: "armored",
            count: Math.max(1, Math.floor((4 + Math.floor(index / 2)) / 2)),
            delayMs: 9000,
            spacingMs: 900,
        });
    }
    if (index >= 6) {
        spawns.push({
            type: "flyer",
            count: Math.max(1, Math.floor((3 + Math.floor(index / 3)) / 2)),
            delayMs: 7000,
            spacingMs: 800,
        });
    }
    return { index, spawns };
}
//# sourceMappingURL=waves.js.map